import { ApexApiError } from 'apex-ui-services'
import { AxiosResponse } from 'axios'
import { Dispatch } from 'redux'
import { getTransferDetails as getTransferDetailsApi } from '../api/transferDetailsApi'
import { HttpResponseStatusCodes } from '../constants'
import { TEMPORARILY_UNAVAILABLE, TRANSFER_RETRIEVAL_FAILED } from './constants'

export const GET_TRANSFER_DETAILS = 'GET_TRANSFER_DETAILS'
export const GET_TRANSFER_DETAILS_SUCCESS = 'GET_TRANSFER_DETAILS_SUCCESS'
export const GET_TRANSFER_DETAILS_FAILURE = 'GET_TRANSFER_DETAILS_FAILURE'

export const getTransferDetails = (
  dispatch: Dispatch,
  acatsControlNumber: string,
  onError: (error: string) => void
) => {
  dispatch({ type: GET_TRANSFER_DETAILS })
  getTransferDetailsApi(acatsControlNumber)
    .then((response: AxiosResponse) => {
      const transferDetails = response.data
      dispatch({ type: GET_TRANSFER_DETAILS_SUCCESS, transferDetails })
    })
    .catch((error: ApexApiError) => {
      const httpResponseStatus = error.response?.status
      const errorMessage =
        httpResponseStatus &&
        httpResponseStatus >= HttpResponseStatusCodes.InternalServerError
          ? TEMPORARILY_UNAVAILABLE
          : TRANSFER_RETRIEVAL_FAILED
      dispatch({ type: GET_TRANSFER_DETAILS_FAILURE })
      onError(errorMessage)
    })
}
